import React from 'react';

import { isReadyToImport } from '../handlers/jira/unmatchedWorklogs';
import { useApp } from '../store/AppContext';
import UnmatchedWorklogRow from './UnmatchedWorklogRow';
import YearImportStats from './YearImportStats';

/* Résultat d'une synchro complète : compteurs, worklogs à rattacher, import de ceux qui sont prêts. */
export default function YearImportResult() {
  const { handleImportAllReady, setYearImportModal, yearImportModal } = useApp();
  if (!yearImportModal.result) return null;
  const unmatched = yearImportModal.unmatched || [];
  const readyCount = unmatched.filter(isReadyToImport).length;
  return (
    <>
      <div className="font-medium text-[14px] mb-[12px]">Import terminé</div>
      <YearImportStats ym={yearImportModal} />
      {unmatched.length > 0 && (
        <>
          <div className="text-[11px] font-semibold text-[#92600A] mb-[6px] uppercase tracking-[0.05em]">
            Non trouvés — remapper pour importer
          </div>
          <div className="overflow-y-auto [flex:1] [border:1px_solid_#f0ede8] rounded-[8px] mb-[12px]">
            {unmatched.map((e, i) => (
              <UnmatchedWorklogRow key={i} e={e} i={i} />
            ))}
          </div>
        </>
      )}
      <div className="flex justify-between items-center">
        <button className="btn" onClick={() => setYearImportModal(null)}>
          Fermer
        </button>
        {readyCount > 0 && (
          <button className="btn btn-primary" onClick={handleImportAllReady}>
            Importer les {readyCount} prêtes
          </button>
        )}
      </div>
    </>
  );
}
